export class AppConstants {
   public static get baseURL(): string { return "https://sabkuch5.sabkuchworld.com/api"; }
 // public static get baseURL(): string { return "http://localhost:50353/api"; }
  //public static get testURL(): string { return "https://sabkuch.mysuru.com/api"; }

}



// WEBPACK FOOTER //
// ./src/app/constants/siteConstants.ts